import { FC } from 'react';

import { cpcFlexiblePlaceOnPlatformElementShownRaw } from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/cpc_flexible_place_on_platform_element_shown';
import { Button, VSpacing } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';
import useIsNewCampaign from 'utils/campaign/hooks/useIsNewCampaign';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { AdExamplesModal } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/AdExamplesCard/AdExamplesModal/AdExamplesModal';
import { CardCommonContent } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/CardCommonContent/CardCommonContent';

import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useSelector } from 'store/utils';

const TrlKeys = {
    title: 'AdCreate.AdForm.AdSources.AdExamplesCard.title',
    description: 'AdCreate.AdForm.AdExamplesCard.description',
    button: 'AdCreate.AdForm.AdSources.AdExamplesCard.link',
};

const AdExamplesCardComponent: FC = () => {
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const isCampaignProcessCreate = useIsNewCampaign();
    const [isModalVisible, setIsModalVisibleOn, setIsModalVisibleOff] = useOnOffState(false);

    const trls = useTrls();

    return (
        <CardCommonContent title={trls(TrlKeys.title)} text={trls(TrlKeys.description)} style="secondary">
            <VSpacing default={20} />
            <Button
                mode="primary"
                style="neutral"
                size="small"
                onClick={() => {
                    if (isCampaignProcessCreate) {
                        cpcFlexiblePlaceOnPlatformElementShownRaw({ vacancyId });
                    }
                    setIsModalVisibleOn();
                }}
                data-qa="show-ad-examples-modal"
            >
                {trls(TrlKeys.button)}
            </Button>
            <AdExamplesModal isModalVisible={isModalVisible} hideModal={setIsModalVisibleOff} />
        </CardCommonContent>
    );
};

const AdExamplesCard = withErrorBoundary(AdExamplesCardComponent);
export { AdExamplesCard };
